/**
 * 바이트 크기 표시.
 *
 * Owns:
 * - 1024 기준 단위 환산과 자릿수 정책, 값 없음의 표기.
 *
 * Does not own:
 * - 무엇의 크기인지 — 호출부가 라벨로 말한다.
 */
const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB", "PB"] as const;

const EMPTY = "—";

/**
 * 예) `12 B` · `1.2 GB` · `340 MB`.
 *
 * 100 이상은 정수 자리, 미만은 소수 1자리로 보여 목록 폭을 좁게 유지한다. 로케일 compact
 * 표기를 쓰지 않으므로 `6억byte` 같은 그룹핑 버그가 없다.
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || !Number.isFinite(bytes) || bytes < 0) {
    return EMPTY;
  }

  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  // B 는 정수 단위라 소수점을 붙이지 않는다.
  if (unitIndex === 0) {
    return `${value} ${BYTE_UNITS[0]}`;
  }

  return `${value >= 100 ? value.toFixed(0) : value.toFixed(1)} ${BYTE_UNITS[unitIndex]}`;
}
